var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',{staticClass:"rc-title__colgroup"},_vm._l((_vm.columns),function(item,index){return _c('col',_vm._b({key:'colgroup_'+index,style:(item.data.staticStyle)},'col',_vm.getAttrs(item),false))}),0)}
var staticRenderFns = []

export { render, staticRenderFns }